import React from 'react';
import { useHistory } from 'react-router-dom';
import { useModal } from 'store/modal';
import { useTranslation } from 'react-i18next';
import API from 'core/Api';

const ClearCacheComponent: React.FC = () => {
  const history = useHistory();
  const { showModal } = useModal();
  const { t } = useTranslation();

  React.useEffect(() => {
    // Function to clear local storage items starting with 'ehr_'
    const clearLocalStorage = () => {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('ehr_')) {
          localStorage.removeItem(key);
        }
      });
    };

    // Function to unregister service workers
    const unregisterServiceWorkers = async () => {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        registrations.forEach(registration => {
          registration.unregister();
        });
      }
    };

    const performHealthCheckAndCleanUp = async () => {
      try {
        const response = await API.get('/health-check');
        const feVersion = response.data.fe_version;

        // Clear local storage and unregister service workers
        clearLocalStorage();
        unregisterServiceWorkers();

        showModal({
          type: 'success',
          content: `${t('common.cacheVersion')} ${feVersion}`,
        });

        history.push('/');
      } catch (error) {
        // console.error('Failed to perform health check:', error);
        // TODO: Handle the error appropriately
      }
    };

    performHealthCheckAndCleanUp();
  }, [history]);

  return <></>;
};

export default ClearCacheComponent;
